module.exports = {
    "Empty": `Prazen`
};


//# sourceMappingURL=sl-SI.main.js.map
